import { isNotNull } from 'core/utils/isNotNull';
import { Conversation } from 'generated-graphql/types';

export const selectedParticipantsMapper = (conversations: Conversation[]) =>
  conversations
    .filter((conversation) => isNotNull(conversation.participantFirstName))
    .map((conversation) => ({
      firstName: conversation.participantFirstName as string,
      lastName: conversation.participantLastName,
      email: conversation.participantEmailAddress,
      phoneNumber: conversation.participantPhoneNumber,
      conversationId: conversation.id
    }));
